import React from "react";
import { transparentize } from "polished";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import { AttachFile, Delete } from "@material-ui/icons";
import { ThemeType } from "@theme";

type File = {
  name: string;
};

type Props = {
  files: File[];
  onDelete?: (i: number) => void;
};

export function FileList(props: Props) {
  const classes = useStyles({});

  return (
    <List dense>
      {props.files.map((file, i) => (
        <ListItem key={i} button style={{ paddingLeft: 0, paddingRight: 0 }}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <AttachFile />
          </ListItemIcon>

          <ListItemText primary={file.name} style={{ flexGrow: 0 }} />

          <div className={classes.placeholder} />

          <div className={classes.icons}>
            <Delete onClick={() => props.onDelete(i)} />
          </div>
        </ListItem>
      ))}
    </List>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  placeholder: {
    borderBottom: `1px dashed ${transparentize(0.4, theme.separatorColor)}`,
    flex: "1 0 0",
    marginBottom: -8,
    marginLeft: 4
  },

  icons: {
    ...theme.mixins.childrenMarginRight(theme.spacing(1 / 2)),
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",

    "& > *": {
      cursor: "pointer",
      color: theme.palette.grey[700],
      transition: theme.transitions.create("color")
    },
    "& > *:hover, & > *:active": {
      color: theme.palette.primary.main
    }
  }
}));
